import { useAtom } from 'jotai';
import { imageDialogAtom } from '../atoms';

/* eslint-disable no-extra-boolean-cast */
interface Props {
  files?: File[];
  urls?: string[];
  onRemoveFile?: (files: File[]) => void;
}

export function FilePreview({ files, urls, onRemoveFile }: Props) {
  const [, setImageDialogState] = useAtom(imageDialogAtom);

  if (!!files?.length)
    return (
      <div className="flex flex-wrap gap-2 mt-2">
        {files.map((file, i) => (
          <div className="relative" key={`${file.name}-${i.toString()}`}>
            <img src={URL.createObjectURL(file)} height="100" width="100" alt="currentScreenshot" />
            {!!onRemoveFile && (
              <span
                className="absolute -top-2 -right-2 grid place-items-center h-6 w-6 text-label bg-neutral-900 text-neutral-50 rounded-full cursor-pointer"
                onClick={() => onRemoveFile(files.filter((el) => el !== file))}
              >
                x
              </span>
            )}
          </div>
        ))}
      </div>
    );

  if (!!urls?.length)
    return (
      <div className="flex flex-wrap gap-2 mt-2">
        {urls.map((url, index) => (
          <img
            // eslint-disable-next-line react/no-array-index-key
            key={`${url}-${index}`}
            src={url}
            height="100"
            width="100"
            alt="currentScreenshot"
            className="cursor-pointer h-[100px] w-[100px] object-center overflow-hidden object-cover"
            onClick={() => setImageDialogState({ isOpen: true, urls, index })}
          />
        ))}
      </div>
    );

  return null;
}
